import { useEffect, useRef, useState } from "react";
import jsQR from "jsqr";

// ماسح QR بسيط: يفتح الكاميرا الخلفية ويقرأ الإطارات كل 250ms حتى يجد رمزاً.
export const useQrScanner = (active, onFound) => {
  const videoRef = useRef(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!active) return undefined;
    let stream;
    let timer;
    let done = false;
    const canvas = document.createElement("canvas");

    const scan = () => {
      const video = videoRef.current;
      if (!video || video.readyState !== 4) return;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const found = jsQR(data, canvas.width, canvas.height);
      if (found?.data && !done) {
        done = true;
        onFound(found.data);
      }
    };

    navigator.mediaDevices
      .getUserMedia({ video: { facingMode: { ideal: "environment" } } })
      .then((s) => {
        stream = s;
        if (videoRef.current) {
          videoRef.current.srcObject = s;
          videoRef.current.play().catch(() => {});
        }
        timer = setInterval(scan, 250);
      })
      .catch(() => setError("camera"));

    return () => {
      clearInterval(timer);
      stream?.getTracks().forEach((track) => track.stop());
    };
  }, [active, onFound]);

  return { videoRef, error };
};
